import './S_PaginationPageSize.scss';
import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_PaginationSelect } from '../paginationControls/paginationSelect/S_PaginationSelect';
import { PaginationItem } from '../PaginationItem';
import { pageSizeOptions } from './S_PaginationPageSizeOptions';

interface IProps {
  pageSize: number;
  pageSizeLabel?: TranslationKey;
  onChange: (selectedPageSize: number) => Promise<void>;
}

export const S_PaginationPageSize = ({ pageSize, pageSizeLabel, onChange }: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='pagination-page-size'>
      <PaginationItem className='pagination-page-size-label'>{t(pageSizeLabel ?? 'pagination.show')}</PaginationItem>
      <PaginationItem className='pagination-page-size-select'>
        <S_PaginationSelect
          options={pageSizeOptions}
          selected={pageSize}
          onChange={onChange}
        />
      </PaginationItem>
    </div>
  );
};
